module.exports = __webpack_public_path__ + "static/img/broadcast.057cf412.png";